'use client';

import React from 'react';

interface UsageStatProps {
  name: string;
  used: number;
  limit: number;
}

const UsageBar: React.FC<{ used: number; limit: number }> = ({ used, limit }) => {
  const percentage = limit > 0 ? (Math.min(used, limit) / limit) * 100 : 0;
  const isUnlimited = limit === Infinity || limit === -1;
  const exceeded = !isUnlimited && limit > 0 && used >= limit;

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5">
      <div
        className={(exceeded ? 'bg-red-600' : 'bg-blue-600') + ' h-2.5 rounded-full'}
        style={{ width: `${isUnlimited ? 100 : percentage}%` }}
      ></div>
    </div>
  );
};

const UsageStat: React.FC<UsageStatProps> = ({ name, used, limit }) => {
  const isUnlimited = limit === Infinity || limit === -1;
  const exceeded = !isUnlimited && limit > 0 && used >= limit;
  
  // Special case: VIP trial users with usage > 0 but limit = 0 (special access)
  const isSpecialAccess = limit === 0 && used > 0;

  return (
    <div>
      <div className="flex justify-between text-sm font-medium">
        <span className={exceeded ? 'text-red-700' : isSpecialAccess ? 'text-blue-700' : 'text-gray-700'}>
          {name}
        </span>
        <span className={exceeded ? 'text-red-700' : isSpecialAccess ? 'text-blue-700' : 'text-gray-700'}>
          {isSpecialAccess ? (
            <>{used}</>
          ) : (
            <>{used} / {isUnlimited ? 'Unlimited' : limit}</>
          )}
        </span>
      </div>
      <div className="mt-1">
        <UsageBar used={used} limit={limit} />
      </div>
    </div>
  );
};

export default UsageStat;
